// useAdComponents.tsx
import {
  AdsImu1Article,
  AdsMidArticle,
} from "@elements/Advertisement/variant/AdsImu";
import {
  CompanionAdsImu1Article,
  CompanionAdsMidArticle,
} from "@elements/Advertisement/variant/CompanionAdImu";

import { ArticleParagraphProps } from "../ArticleParagraph";

export function AdsComponents({
  adsUniqueSectionName,
  gsChannels,
  articleSlotTarget,
  isInfiniteScrollArticle,
  pageNumber,
}: Pick<
  ArticleParagraphProps,
  | "adsUniqueSectionName"
  | "gsChannels"
  | "articleSlotTarget"
  | "isInfiniteScrollArticle"
  | "pageNumber"
>) {
  if (isInfiniteScrollArticle) {
    return {
      adsImu1: (
        <CompanionAdsImu1Article
          uniqueSectionName={adsUniqueSectionName}
          index={pageNumber}
          gsChannels={gsChannels}
          articleSlotTarget={articleSlotTarget}
        />
      ),
      adsMidArticle: (
        <CompanionAdsMidArticle
          uniqueSectionName={adsUniqueSectionName}
          index={pageNumber}
          gsChannels={gsChannels}
          articleSlotTarget={articleSlotTarget}
        />
      ),
    };
  }

  return {
    adsImu1: (
      <AdsImu1Article
        uniqueSectionName={adsUniqueSectionName}
        isArticlePage={true}
        gsChannels={gsChannels}
        articleSlotTarget={articleSlotTarget}
      />
    ),
    adsMidArticle: (
      <AdsMidArticle
        uniqueSectionName={adsUniqueSectionName}
        isArticlePage={true}
        gsChannels={gsChannels}
        articleSlotTarget={articleSlotTarget}
      />
    ),
  };
}
